import React from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import {
	FormDropdownField,
	FormInputField,
} from "../custom_form_component/CustomFormComponent";
import { useSelector, useDispatch } from "react-redux";
import { LoadingBar } from "../loading_bar/LoadingBar";
import { createAdmin, reset } from "../../features/admin/adminSlice";
import {
	DetailsBody,
	DetailsFooter,
	DetailsHeader,
	DetailsHeaderDesc,
	DetailsPanelStyled,
} from "../../styles/admin/DetailsPanel";
import { PanelForm, PanelRow } from "../../styles/admin/Forms.styled";
import { FormPanelButton } from "../../styles/FormPanel.Styled";
import formValidator from "../../misc/validator";

const formDefaults = {
	first_name: "",
	last_name: "",
	email: "",
	phone_number: "",
	status: "",
	role: "",
};

const roleOptions = [
	{ label: "Admin", value: "admin" },
	{ label: "Customer Care Support", value: "customer-care" },
	{ label: "Manager", value: "manager" },
];

function CreateTeamMemberPanel({ onClose }) {
	const {
		handleSubmit,
		control,
		reset: resetForm,
		formState: { errors },
	} = useForm({
		defaultValues: formDefaults,
	});

	const dispatch = useDispatch();
	const ref = React.useRef(null);

	const { data, isError, isSuccess, isCreateAdmin,  isLoading, message } = useSelector(
		(state) => state.admin
	);
	React.useEffect(() => {
        if(isError){
            toast.error(message)
            ref.current.complete()
        }

		if (isSuccess && data && isCreateAdmin) {
			ref.current.complete();
			toast.success("Team Member Created Successfully!");
			resetForm(formDefaults);
		}

		dispatch(reset());
	}, [data, isError, isSuccess, isCreateAdmin, message, onClose, resetForm, dispatch]);
	const onSubmit = (data) => {
        if(!isLoading){
            ref.current.continuousStart();
            dispatch(createAdmin(data));
        }
        
	};

	return (
        <>
        <LoadingBar ref={ref} shadow={true} />
		<DetailsPanelStyled as="form" onSubmit={handleSubmit(onSubmit)}>
			<DetailsHeader>
				<DetailsHeaderDesc>
					<h3>Add team member</h3>
				</DetailsHeaderDesc>
			</DetailsHeader>
			<DetailsBody padding="2rem">
				<PanelForm>
					<PanelRow>
						<FormInputField
							name="first_name"
							label="First Name"
							placeholder="eg. John"
							control={control}
							errors={errors}
						/>
					</PanelRow>
					<PanelRow>
						<FormInputField
							name="last_name"
							label="Last Name"
							placeholder="eg. Chris"
							control={control}
							errors={errors}
						/>
					</PanelRow>
					<PanelRow>
						<FormInputField
							name="email"
							label="Email Address"
							type="email"
							rules={{
								required: {
									value: "required",
									message: "Please enter email address",
								},
								validate: formValidator.emailValidator,
							}}
							placeholder="e.g you@example.com"
							control={control}
							errors={errors}
						/>
					</PanelRow>
					<PanelRow>
						<FormInputField
							name="phone_number"
							label="Phone Number"
							rules={{
								required: {
									value: "required",
									message: "Please enter phone number",
								},
								validate: formValidator.phoneValidator,
							}}
							type="tel"
							placeholder="e.g +23494394493"
							control={control}
							errors={errors}
						/>
					</PanelRow>
					
                    <PanelRow>
						<FormDropdownField
							name="role"
							label="Role"
							options={roleOptions}
							control={control}
							placeholder="Choose role"
							rules={{
								required: {
									value: "required",
									message: "Please select role",
								},
							}}
							errors={errors}
						/>
					</PanelRow>
				</PanelForm>
			</DetailsBody>
			<DetailsFooter>
				<div></div>
				<div>
					<FormPanelButton type="submit" primary>
						Create Team Account
					</FormPanelButton>
				</div>
			</DetailsFooter>
		</DetailsPanelStyled>
        </>
	);
}

export default CreateTeamMemberPanel;
